<script setup lang="ts">
import { parseTime, floorDate } from '#shared'
import { ref, watch } from 'vue'

const { modelValue } = defineProps<{ modelValue: Date | null }>()

const emit = defineEmits<{ 'update:modelValue': [value: Date | null] }>()

const inputValue = ref('')
watch(
  () => modelValue,
  modelValue => {
    if (!modelValue) return (inputValue.value = '')

    const hours = modelValue.getHours()
    const minutes = modelValue.getMinutes()

    inputValue.value = `${hours}:${minutes.toString().padStart(2, '0')}`
  },
  { immediate: true }
)

const onInputBlur = () => {
  const [hours, minutes] = parseTime(inputValue.value)

  const date = floorDate(modelValue ?? new Date(), { unit: 'minute' })
  date.setHours(hours)
  date.setMinutes(minutes)
  emit('update:modelValue', date)
}
</script>

<template>
  <input :class="$style.root" v-model="inputValue" @blur="onInputBlur" />
</template>

<style lang="scss" module>
@use '#mixins/input' as input;
@use '#mixins/button' as button;

.root {
  @include input.underline;

  & {
    padding-left: 10px;
    padding-right: 10px;
    outline: none;
  }
}
</style>
